import styled from 'styled-components';
import DailyHouseKeepingIconSvg from '../../assets/hotels/amenities/DailyHousekeeping.svg';

const DailyHouseKeepingIcon = styled(
  DailyHouseKeepingIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>,
)`
  width: ${props => props.width || '2rem'};
  height: ${props => props.height || '2rem'};
  fill: ${props => props.fill || props.theme.colors.grey.grey50};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default DailyHouseKeepingIcon;
